/**
 * Utility function to open Stripe Checkout in a new browser tab
 * 
 * CRITICAL: Stripe Checkout cannot run in iframes or popup windows.
 * This function opens the checkout URL in a proper new browser tab.
 * 
 * @param sessionUrl - Stripe Checkout session URL
 * @returns void
 */
export function prepareStripeCheckoutWindow(): Window | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const newWindow = window.open('about:blank', '_blank');
  if (newWindow) {
    newWindow.opener = null;
  }
  return newWindow;
}

export function openStripeCheckout(sessionUrl: string, existingWindow?: Window | null): void {
  if (typeof window === 'undefined') {
    return;
  }

  if (existingWindow && !existingWindow.closed) {
    existingWindow.location.href = sessionUrl;
    existingWindow.focus();
    return;
  }

  const newWindow = window.open(sessionUrl, '_blank');
  if (newWindow) {
    newWindow.opener = null;
    newWindow.focus();
    return;
  }

  // Fallback: create a temporary anchor element
  const link = document.createElement('a');
  link.href = sessionUrl;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
